<template>
    <div class="app-container">


        <div :class="showType ? 'banner__layer' : 'banner__layer bannerss'">



            <div :class="showType ? 'banner-content content-box' : 'banner-content content-box banner-co'">
                <img class="top-img" src="../../../../static/index/top-app.png" alt="" />
                <img class="waplogo" src="../../../../static/common/waplogo.png" alt="">
                <h1 class="title">海量数据 简洁呈现</h1>
                <h1 class="titles">海量数据 </h1>
                <h1 class="titles">简洁呈现</h1>
                <p class="banner-content-intro">助您轻松投资 · 掌握方向</p>
                <div class="banner-content-download">
                    <router-link to="/Appdownload?key=1">
                        <span class="banner-content-download-btn">APP下载</span>
                        <span class="banner-content-download-btn1">立即下载 →</span>
                        
                    </router-link>

                </div>
                <div class="banner-content-download-text">
                    <div>
                        <img src="@/assets/imgs/mobie-icon.png" alt="">
                        <span>
                            支持多平台 <br />
                            双端互通
                        </span>
                    </div>
                    <div>
                        <img src="@/assets/imgs/user-black-icon.png" alt="">
                        <span>
                            简单 <br />
                            易用
                        </span>
                    </div>
                </div>
            </div>

        </div>


        <div class="about-cooperate">
            <div class="title__layer">
                <h1><span>平台</span>交易客户展示</h1>
                <p>精准洞察，助力客户成交</p>
            </div>
            <div class="flex">
                <DetailFirst></DetailFirst>

            </div>
        </div>
        <div class="about-cooperate">
            <div class="title__layer">
                <h1>持仓比例</h1>
                <p>以下图表显示了本平台客户的持仓数据，包括多头与空头之比例、持仓比例</p>
                <p>数据信息代表了目前交易的趋势与方向。客户可参考这些交易数据，从而制定个人的交易策略</p>
            </div>
            <div class="bigBox">
                <div class="echartsBox">

                    <div class="sjBox">
                        <d-echarts v-if="topEcharts.length > 0" :msg="topEcharts[1]" :isWap="showWap"></d-echarts>
                    </div>
                    <p v-if="topEcharts.length > 0" class="tits">伦敦金</p>
                    <p v-if="topEcharts.length > 0">数据最新更新时间：&nbsp; {{ topEcharts[1].CreateTime }}</p>
                </div>
                <div class="echartsBox">

                    <div class="sjBox">
                        <d-echarts v-if="topEcharts.length > 0" :msg="topEcharts[0]" :isWap="showWap"></d-echarts>
                    </div>
                    <p v-if="topEcharts.length > 0" class="tits1">伦敦银</p>
                    <p v-if="topEcharts.length > 0">数据最新更新时间：&nbsp; {{ topEcharts[0].CreateTime }}</p>
                </div>
            </div>
        </div>
        <div class="about-cooperate">
            <div class="title__layer">
                <h1>未平仓品种比率</h1>
                <p>市场热度与趋势的晴雨表</p>
            </div>
            <div class="flex">
                <ul class="product-grade">
                    <li class="product-grade-cell" v-for="(item, index) in bottomEharts" :key="'grade-' + index">
                        <span>{{ item.name }}</span>
                        <span>{{ item.value + '%' }}</span>
                    </li>
                </ul>

            </div>
            <p class="time">更新时间：&nbsp; {{ echartDatabottom }}数据仅供参考</p>

        </div>

    </div>
</template>

<script>

import DetailFirst from './components/detailFirst.vue'
import DEcharts from './components/detailSecond.vue';

import { datacenterGoldSilverScale } from '@/apis/common';
import { queryGoldSilverComman } from '@/apis/common'

export default {
    name: 'Index',
    components: {

        DetailFirst,
        DEcharts
    },

    data() {
        return {
            bottomEharts: [
                { name: '品种名称', value: '百分比' },
                { name: '伦敦金', value: '' },
                { name: '伦敦银', value: '' }
            ],
            echartDatabottom: '',
            topEcharts: [],
            topEcharts: [],

            showWap: document.body.clientWidth > 500 ? false : true,
            screenWidth: document.body.clientWidth,
            showType: true
        }
    },
    created() {

        this.$emit('controlShow', false);

        queryGoldSilverComman({ "hours": "24" }).then(res => {

            if (res&&res.length > 0) {
                this.topEcharts = res;

            } else {
                this.topEcharts = [
                    {
                        "BuyScale": "42.94",
                        "Symbol": "GOLD",
                        "CreateTime": "2026-01-29T15:13:52.797",
                        "SellCount": 307,
                        "Count": 538,
                        "SellScale": "57.06",
                        "BuyCount": 231
                    },
                    {
                        "BuyScale": "60.29",
                        "Symbol": "SILVER",
                        "CreateTime": "2026-01-29T15:13:52.797",
                        "SellCount": 27,
                        "Count": 68,
                        "SellScale": "39.71",
                        "BuyCount": 41
                    }
                ];

            }

        }).catch(err => {
            console.log(err);
        })
        // 未平仓品种比率
        datacenterGoldSilverScale().then(res => {
            this.bottomEharts[1].value = res.GoldScale.toString();
            this.bottomEharts[2].value = res.SilverScale.toString();
            this.echartDatabottom = res.CreateTime;

        }).catch(err => {
            console.log(err);
        })
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);

    },
    methods: {
        handleScroll() {

            if (this.screenWidth > 500) {
                this.showWap = false
            } else {
                this.showWap = true
            }
        },

    },
    destroyed() {
        this.autoScroll(true)
    }
}
</script>
<style lang="less" scoped>
.app-container {
    background: #fafafa;

    .content-box {
        width: 1240px;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .banner__layer {
        width: 100%;
        height: 810px;
        background:linear-gradient(100.69deg, rgba(0, 0, 0, 0.6) 27.87%, rgba(10, 10, 10, 0) 72.52%, rgba(10, 10, 10, 0.2) 100%), url('../../../assets/imgs/banner.png') no-repeat;
        background-size: 100% 100%;

        // padding-top: 80px;
        .banner-img {
            display: block;
            width: 100%;
            height: 810px;
        }

        .banner-imgs {
            display: none;
            width: 100%;
        }

        .banner-content {
            padding-top: 163px;
            width: 1240px;
            margin: 0 auto;
            color: #FFFFFF;

            .top-img {
                width: 139px;
                height: 38px;
            }

            .waplogo {
                display: none;
            }

            .title {
                display: block;
                font-size: 80px;
                font-weight: 700;
                line-height: 106px;
                margin: 34px 0 26px 0;
            }

            .titles {
                display: none;
            }

            h1 {
                font-size: 68px;
                margin: 0;
            }

            &-intro {
                font-size: 18px;
                font-size: 26px;

                line-height: 34px;
            }

            &-download {
                display: flex;
                align-items: center;
                margin-top: 50px;

                &-btn {
                    width: 198px;
                    line-height: 56px;
                    color: #FFFFFF;
                    background: #FA2314;
                    border-radius: 100px;

                    cursor: pointer;
                    text-align: center;
                    font-size: 20px;
                    font-weight: 700;
                    display: inline-block;
                    margin-bottom: 54px;
                }
                &-btn1{
                    display: none;
                }

                &-text {
                    display: flex;
                    align-items: center;

                    >div {
                        display: flex;
                        align-items: center;
                        color: #FFFFFF;
                        // padding: 4px 40px;

                        &:first-child {
                            padding-right: 32px;
                            border-right: 1px solid #0F0F11;
                        }

                        &:last-child {
                            padding-left: 32px;
                        }

                        img {
                            width: 38px;
                            height: 38px;
                            margin-right: 12px;
                        }
                    }
                }
            }
        }
    }

    .title__layer {
        text-align: center;
        padding: 70px 0 50px;

        h1 {
            font-size: 46px;
            margin: 0;
            color: #000;
            margin-bottom: 10px;

            span {
                color: #FA2314;
            }
        }

        p {
            color: #0F0F11;
            font-size: 18px;
        }
    }

    .about-intro {
        margin: 100px auto;
        display: flex;
        align-items: center;

        >img {
            width: 452px;
            margin-right: 60px;
        }

        &-right {
            padding: 26px;

            &-title {
                h1 {
                    font-size: 46px;
                    margin: 0;
                    color: #000;
                    margin-bottom: 10px;

                    span {
                        color: #FA2314;
                    }
                }
            }

            &-text {
                color: #6d6d6d;
                margin-top: 50px;

                span {
                    color: #FA2314;
                }
            }
        }

    }



    .about-cooperate {
        background: #FFFFFF;
        margin-top: 50px;
        padding-bottom: 100px;
        text-align: center;

        >img {
            width: 1132px;
        }
    }

    .flex {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .product-grade {
        background: #FFFFFF;
        margin-bottom: 50px;

        &-cell {

            display: flex;
            text-align: center;
            line-height: 76px;
            border-bottom: 1px solid #EBEEF5;

            span {
                border-right: 1px solid #EBEEF5;

                &:first-child {
                    width: 620px;
                }

                &:nth-child(2) {
                    width: 620px;
                }


            }

            &:first-child {
                background: linear-gradient(to right, #FA2314, #DB2C23);
                color: #FFFFFF;
                font-size: 20px;
                font-weight: 600;

                span {
                    border: none;

                    &:nth-child(4) {

                        background-size: 100% 100%;
                        color: #FFFFFF;
                    }
                }
            }

            &:nth-child(2) {
                span {
                    &:nth-child(1) {
                        color: #D18A1F;

                    }

                    &:nth-child(2) {
                        color: #FA2314;

                    }
                }
            }

            &:nth-child(3) {
                span {
                    &:nth-child(1) {
                        color: #93939F;


                    }

                    &:nth-child(2) {
                        color: #11C771;


                    }
                }
            }
        }
    }

    .time {
        color: #93939F;
        font-size: 12px;
        line-height: 16px;
    }

    .bigBox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 60px;

        .echartsBox {
            width: 49%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            padding-bottom: 10px;
            // box-shadow:0px 0px 95px 0px rgba(43, 53, 105, 0.1);
            border-radius: 15px;
            border-radius: 15px;

            img {
                width: 100%;
            }

            .sjBox {
                width: 70%;
                height: 400px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .tits {
                color: #D18A1F;
                font-size: 20px;
                line-height: 26px;
                font-weight: 700;
            }

            .tits1 {
                color: #93939F;
                font-size: 20px;
                line-height: 26px;
                font-weight: 700;
            }

            p {
                font-size: 14px;
                color: #999999;
                margin-top: 10px;
                white-space: nowrap;
            }
        }
    }
}

@media screen and (max-width: 500px) {
    .app-container {
        .banner__layer {
            // padding-top: 45px;
            height: 705px;
            background: url('../../../assets/imgs/banners.png') no-repeat;
            background-size: 100% 100%;

            .banner-img {
                display: none;
            }

            .banner-imgs {
                display: block;
                height: 500px;

            }

            .banner-content {
                width: 100%;
                margin:  0 auto;
                padding: 40px 0;    
                background: linear-gradient(160.28deg, rgba(0, 0, 0, 0.8) 9.03%, rgba(0, 0, 0, 0.56) 47.92%, rgba(6, 6, 6, 0) 72.9%, rgba(10, 10, 10, 0.2) 100%);
                color: #FFFFFF;
                .waplogo{
                    display: block;
                    width: 110px;
                    height: 30px;
                    margin: 0 auto;
                }
                .top-img{
                    display: none;
                }
                .title {
                    display: none;
                }

                .titles {
                    color: #FFFFFF;
                    display: block;
                }

                h1 {
                    font-size: 58px;
                    line-height: 77px;
                    margin: 0;
                    width: 100%;
                    text-align: center;
                    white-space: wrap;
                }

                &-intro {
                    font-size: 14px;
                    text-align: center;
                }

                &-download {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: 20px;
                    &-btn {
                        display: none;
                    }
                    &-btn1 {
                        display: block;
                        width: 180px;
                        line-height: 34px;
                        color: #FFFFFF;
                        background: #FA2314;
                        border-radius: 100px;
                     
                        cursor: pointer;
                        text-align: center;
                        font-size: 14px;
                        font-weight: 700;
                 
                    }

                    &-text {
                        display: none;
                    }
                }
            }

            .banner-co {
                top: 33%;
            }
        }

        .bannerss {
            padding-top: 0;
        }

        .content-box {
            width: 100%;
            margin: auto;
            box-sizing: border-box;
        }

        .title__layer {
            .title {
                display: none;
            }

            .titles {
                display: block;
            }

            h1 {
                font-size: 36px;
                line-height: 48px;
            }

            p {
                font-size: 14px;
            }
        }

        .about-cooperate {
            padding-bottom: 36px;
            margin-top: 0;

            .mt4 {
                display: none;
            }

            .wapmt4 {
                display: block;
                width: 100%;
            }
        }

        .data-analyse-table {
            width: 100%;
        }

        .product-grade {
            width: 93%;
            margin: 0 auto;

            &-cell {
                &:first-child {
                    font-size: 12px;
                }

                &:nth-child(2),
                &:nth-child(3) {
                    font-size: 10px;
                }
            }
        }

        .bigBox {
            flex-direction: column;

            .echartsBox {

                // width: 80%;
                .sjBox {
                    width: 320px;
                    height: 300px;
                }
            }
        }

    }
}

//---------------- 小屏幕---------------------------
@media screen and (min-width: 1264px) and (max-width: 1724px) {
    .app-container {
        background: #fafafa;

        .content-box {
            width: 1000px;
            margin: auto;
            box-sizing: border-box;
        }

        .banner__layer {
            position: relative;
            // padding-top: 80px;

            .banner-img {
                display: block;
                width: 100%;
            }

            .banner-imgs {
                display: none;
                width: 100%;
            }

            .banner-content {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 11;
                color: #FFFFFF;

                .title {
                    display: block;
                }

                .titles {
                    display: none;
                }

                h1 {
                    font-size: 50px;
                    margin: 0;
                }

                &-intro {
                    font-size: 18px;
                }

                &-download {
                    display: flex;
                    align-items: center;
                    margin-top: 50px;

                    &-btn {
                        width: 198px;
                        line-height: 56px;
                        color: #FFFFFF;
                        background: #FA2314;
                        border-radius: 4px;
                        margin-right: 10px;
                        cursor: pointer;
                        text-align: center;
                        font-size: 20px;
                        font-weight: 700;
                        display: inline-block;
                    }

                    &-text {
                        display: flex;
                        align-items: center;

                        >div {
                            display: flex;
                            align-items: center;
                            color: #FFFFFF;
                            padding: 4px 40px;

                            &:first-child {
                                border-right: 1px solid #0F0F11;
                            }

                            img {
                                width: 38px;
                                height: 38px;
                                margin-right: 12px;
                            }
                        }
                    }
                }
            }
        }

        .title__layer {
            text-align: center;
            padding: 70px 0 50px;

            h1 {
                font-size: 46px;
                margin: 0;
                color: #000;
                margin-bottom: 10px;

                span {
                    color: #FA2314;
                }
            }

            p {
                color: #0F0F11;
                font-size: 18px;
            }
        }

        .about-intro {
            margin: 100px auto;
            display: flex;
            align-items: center;

            >img {
                width: 452px;
                margin-right: 60px;
            }

            &-right {
                padding: 26px;

                &-title {
                    h1 {
                        font-size: 46px;
                        margin: 0;
                        color: #000;
                        margin-bottom: 10px;

                        span {
                            color: #FA2314;
                        }
                    }
                }

                &-text {
                    color: #6d6d6d;
                    margin-top: 50px;

                    span {
                        color: #FA2314;
                    }
                }
            }

        }



        .about-cooperate {
            background: #FFFFFF;
            margin-top: 50px;
            padding-bottom: 100px;
            text-align: center;

            >img {
                width: 1132px;
            }
        }

        .flex {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .product-grade {
            background: #FFFFFF;
            margin-bottom: 50px;

            &-cell {

                display: flex;
                text-align: center;
                line-height: 76px;
                border-bottom: 1px solid #EBEEF5;

                span {
                    border-right: 1px solid #EBEEF5;

                    &:first-child {
                        width: 420px;
                    }

                    &:nth-child(2) {
                        width: 420px;
                    }


                }

                &:first-child {
                    background: linear-gradient(to right, #FA2314, #DB2C23);
                    color: #FFFFFF;
                    font-size: 20px;
                    font-weight: 600;

                    span {
                        border: none;

                        &:nth-child(4) {

                            background-size: 100% 100%;
                            color: #FFFFFF;
                        }
                    }
                }

                &:nth-child(2) {
                    span {
                        &:nth-child(1) {
                            color: #D18A1F;

                        }

                        &:nth-child(2) {
                            color: #FA2314;

                        }
                    }
                }

                &:nth-child(3) {
                    span {
                        &:nth-child(1) {
                            color: #93939F;


                        }

                        &:nth-child(2) {
                            color: #11C771;


                        }
                    }
                }
            }
        }

        .time {
            color: #93939F;
            font-size: 12px;
            line-height: 16px;
        }

        .bigBox {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 60px;

            .echartsBox {

                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                box-sizing: border-box;
                padding-bottom: 10px;
                // box-shadow:0px 0px 95px 0px rgba(43, 53, 105, 0.1);
                border-radius: 15px;
                border-radius: 15px;

                img {
                    width: 100%;
                }

                .sjBox {
                    width: 100%;
                    height: 400px;

                }

                .tits {
                    color: #D18A1F;
                    font-size: 20px;
                    line-height: 26px;
                    font-weight: 700;
                }

                .tits1 {
                    color: #93939F;
                    font-size: 20px;
                    line-height: 26px;
                    font-weight: 700;
                }

                p {
                    font-size: 14px;
                    color: #999999;
                    margin-top: 10px;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>